import React, { ReactNode } from 'react'
import { Box, BoxProps, styled } from '@mui/material'

// TODO: Time me !!!
const StyledCard = styled(Box)<{ boxShadow?: any }>(({ boxShadow }) => ({
  boxShadow: boxShadow || '0px 3px 5px 2px #0000000D',
  borderRadius: '10px',
  backgroundColor: '#FFFFFF',
}))

// const StyledCard = styled(
//   Box,
//   {}
// )<{ boxShadow?: string | number }>(
//   ({ boxShadow }) => `
//      boxShadow: ${boxShadow || '0px 3px 5px 2px #0000000D'},
//      borderRadius: '10px',
//      backgroundColor: '#FFFFFF',`
// )

const StyledCardHeader = styled(Box)({
  boxShadow:
    '0px 4px 6px rgba(0, 0, 0, 0.04), 0px 1px 3px rgba(238, 237, 237, 0.04)',
  height: '60px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: 8,
})

type CardProps = BoxProps & {
  children: ReactNode
}

type CardHeaderProps = BoxProps & {
  children: ReactNode
}

export const Card: React.FC<CardProps> = ({ children, ...props }) => {
  return <StyledCard {...props}>{children}</StyledCard>
}

export const CardHeader: React.FC<CardHeaderProps> = ({
  children,
  ...props
}) => {
  return <StyledCardHeader {...props}>{children}</StyledCardHeader>
}
